import { TIMESPAN_WEEK } from 'constants/filters';
import { usersPageFilterFactory, usersPageSort } from 'factories/filter';
import type { Reducer } from 'redux';
import { combineReducers } from 'redux';
import * as hoursTypes from 'redux/modules/hours.types';
import type {
  ControlState,
  Filter,
  Query,
  Totals,
  State as UsersListState,
} from 'redux/modules/users-page/users-list/usersList.types';
import {
  clearQuery,
  clearTotals,
  fetchedTotals,
  hideDetails,
  setFilters,
  setQuery,
  showDetails,
  sortBy,
} from 'redux/modules/users-page/users-list/usersList.types';
import { reducerWithInitialState } from 'typescript-fsa-reducers';

export const initialQueryState: Query = usersPageFilterFactory({ span: TIMESPAN_WEEK }, 1);

export const usersListQueryReducer = reducerWithInitialState(initialQueryState)
  .case(setQuery, (state, payload) => {
    return {
      ...state,
      ...usersPageFilterFactory({ ...state, ...payload.query }, payload.startOfWeek),
    };
  })
  .case(clearQuery, state => {
    return { ...state, ...usersPageFilterFactory({}, 1) };
  })
  .case(sortBy, (state, payload) => {
    return {
      ...state,
      sort: usersPageSort(payload),
    };
  });

export const initialTotalsState: Totals = {};

export const usersListTotalsReducer = reducerWithInitialState(initialTotalsState)
  .caseWithAction(fetchedTotals, (state, action) => {
    return {
      ...state,
      [action.meta!.key]: action.payload,
    };
  })
  .case(clearTotals, () => {
    return {};
  });

const controlReducer = reducerWithInitialState<ControlState>({
  shouldReload: false,
  detailsRef: null,
})
  .case(showDetails, (state, detailsRef) => {
    return {
      ...state,
      detailsRef,
    };
  })
  .case(hideDetails, state => {
    return {
      ...state,
      detailsRef: null,
      shouldReload: false,
    };
  })
  .case(hoursTypes.savedHour, state => {
    if (state.detailsRef) {
      return {
        ...state,
        shouldReload: true,
      };
    }
    return state;
  });

export const initialFiltersState: Filter = {
  userIds: undefined,
  teamIds: undefined,
};

const filtersReducer = reducerWithInitialState<Filter>(initialFiltersState).case(
  setFilters,
  (state, filters) => {
    return {
      ...state,
      ...filters,
    };
  }
);

const usersListReducer: Reducer<UsersListState> = combineReducers({
  query: usersListQueryReducer,
  filters: filtersReducer,
  totals: usersListTotalsReducer,
  control: controlReducer,
});

export default usersListReducer;
